import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects';
import qs from 'qs';
import TemplateActionType from 'actions/template/templateActionType';
import {
  changeLoadingState, setSuccessMessage, setErrorMessage, changeEndedStatus,
} from 'app/settings/slices';
import {
  saveTemplates, saveTemplatesTotal,
} from 'actions/template/templateActionCreator';
import NetworkService from 'services/networkService';
import { selectTemplatesTotal, selectTemplates } from 'selectors';
import { i18n } from 'services';
import { AppConstants } from 'constants/index';
import { getError, getMessage } from 'utils/helpers';
import { isJSON } from 'utils/utils';

function* createCustomTemplate({ payload }) {
  try {
    const { name, isDraft } = payload.data;
    const { NotificationAdmin, CustomTemplate } = AppConstants.api;
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPostRequest, [NotificationAdmin, CustomTemplate], payload);
    yield put(setSuccessMessage(getMessage(i18n.t('communication:lTemplate'), i18n.t(isDraft ? 'notification:slSavedAsDraft' : 'notification:slCreated'), name)));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editCustomTemplate({ payload }) {
  try {
    const { name } = payload.data;
    const { NotificationAdmin, CustomTemplate } = AppConstants.api;
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPutRequest, [NotificationAdmin, CustomTemplate], payload);
    yield put(setSuccessMessage(getMessage(i18n.t('communication:lTemplate'), i18n.t('notification:slUpdated'), name)));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getCustomTemplates({ payload }) {
  try {
    const options = {
      params: payload.data,
      paramsSerializer: (params) => qs.stringify(params),
    };
    yield put(changeLoadingState(true));
    const { NotificationAdmin, CustomTemplate } = AppConstants.api;
    const response = yield call(NetworkService.makeAPIGetRequest, [NotificationAdmin, CustomTemplate], options);
    const { data, total } = response.data;
    const state = yield select();
    const templates = selectTemplates(state.template);
    const totalState = selectTemplatesTotal(state.template);
    yield put(
      saveTemplates({
        ...templates,
        custom: data,
      }),
    );
    yield put(
      saveTemplatesTotal({
        ...totalState,
        custom: total,
      }),
    );
    yield put(changeLoadingState(false));
  } catch (err) {
    yield put(changeLoadingState(false));
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
  }
}

function* deleteCustomTemplate({ payload }) {
  try {
    const { id, name } = payload.data;
    yield put(changeLoadingState(true));
    const { NotificationAdmin, CustomTemplate } = AppConstants.api;
    yield call(NetworkService.makeAPIDeleteRequest, [NotificationAdmin, CustomTemplate, id]);
    yield put(changeEndedStatus(true));
    yield put(setSuccessMessage(getMessage(i18n.t('communication:lTemplate'), i18n.t('notification:slDeleted'), name)));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* templateSaga() {
  yield all([
    takeLatest(TemplateActionType.CREATE_CUSTOM_TEMPLATE, createCustomTemplate),
    takeLatest(TemplateActionType.EDIT_CUSTOM_TEMPLATE, editCustomTemplate),
    takeLatest(TemplateActionType.GET_CUSTOM_TEMPLATES, getCustomTemplates),
    takeLatest(TemplateActionType.DELETE_CUSTOM_TEMPLATE, deleteCustomTemplate),
  ]);
}
